module.exports = __webpack_public_path__ + "static/media/contacto.41ba8eb9.png";